import type { GlobeEngine } from './GlobeEngine';

/** Kept outside the React module so development refresh cannot split imperative access. */
export const globeEngineHolder: { current: GlobeEngine | null } = { current: null };

export function getGlobeEngine(): GlobeEngine | null {
  return globeEngineHolder.current;
}
